module.exports = __webpack_public_path__ + "e315b8b6.svg";